<nz-select [(ngModel)]="selected" (ngModelChange)="onModelChanged($event)" [nzDisabled]="isDisabled" [nzMode]="hxMode"
           nzPlaceHolder="Выберите организацию" [nzDropdownMatchSelectWidth]="false" nzAllowClear nzShowSearch>
  <nz-option *ngFor="let op of options" [nzLabel]="(op.organization.title | uiLabel)" [nzValue]="op.organization.id"></nz-option>
</nz-select>
